"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TaskSearchOverlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var search_overlay_1 = require("../overlay/search-overlay");
var FILTER_TYPE = ["tasks/task"];
exports.TaskSearchOverlay = react_1["default"].memo(function TaskSearchOverlay(props) {
    var onSelectResult = react_1["default"].useCallback(function (r) {
        // Since we filterType to task we can assume it is a TaskResultType
        var result = r;
        props.onTaskSelected(result.task);
    }, [props]);
    return ((0, jsx_runtime_1.jsx)(search_overlay_1.SearchOverlay, { onClose: props.onClose, filterType: FILTER_TYPE, onSelectResult: onSelectResult, tagFilter: props.typeFilter != null ? "task/".concat(props.typeFilter) : null }));
});
